import React from 'react';
import PropTypes from 'prop-types';
import * as ReactRouter from 'react-router-dom';
import {
  homeRoute,
  loginRoute,
  // superAdminHomeRoute,
} from '../../config/navigation/routes';
import { createQueryString } from '../../utils/queryStringUtils';

export default class extends React.PureComponent {
  static propTypes = {
    auth: PropTypes.shape({
      id: PropTypes.string,
      role: PropTypes.string,
      expiration: PropTypes.number,
      organizationId: PropTypes.string,
    }).isRequired,
    roles: PropTypes.arrayOf(PropTypes.string),
    location: PropTypes.object.isRequired,
  };

  static defaultProps = {
    roles: [],
  };

  render() {
    const { auth, roles, location } = this.props;

    if (!auth.id || !auth.organizationId || !auth.role) {
      const intermediateLoginRoute = loginRoute;
      const newQueryParams = {
        redirect: `${location.pathname}${location.search}`,
      };
      return (
        <ReactRouter.Redirect
          to={`${intermediateLoginRoute}?${createQueryString(newQueryParams)}`}
        />
      );
    }

    if (auth.role === 'SUPER_ADMIN') {
      return <ReactRouter.Route {...this.props} />;
    }

    if (!roles || !roles.length || roles.includes(auth.role)) {
      return <ReactRouter.Route {...this.props} />;
    }
    return <ReactRouter.Redirect to={homeRoute} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/AuthRoute.jsx